
export const updateNotifications = (notifications) => (dispatch) => {
  dispatch({
    type: 'UPDATE_NOTIFICATIONS',
    response: { notifications }
  })
}